export class FailedDoor {
  accessPointId: number;
  name: string;
  status: number;
  statusMessage: string;
  selected: boolean;

  constructor();
  constructor(accessPointId: number, name: string, status: number, statusMessage: string, selected: boolean);
  constructor(accessPointId?: number, name?: string, status?: number, statusMessage?: string, selected?: boolean) {
    this.accessPointId = accessPointId;
    this.name = name;
    this.status = status;
    this.statusMessage = statusMessage;
    this.selected = selected;
  }
}
